import { bodyLockToggle } from "./helpers/body-lock-toggle";

window.addEventListener('load', () => {
    let availableCarousels = document.querySelectorAll('.splide');
    let gallerySplidePanel = document.querySelectorAll('.gallery-panel');
    let instagramSplidePanel = document.querySelectorAll('.instagram-panel')
    let mediaSplidePanel = document.querySelectorAll('.slider-panel');
    let elevationsSplidePanel = document.querySelectorAll('.elevations-panel');

    if (availableCarousels.length) {

        // START MEDIA PANEL SLIDER
        for ( let panel of mediaSplidePanel ) {
            let parentPanel = panel.closest('.slider-panel');
            let totalSlides = parentPanel.querySelector('.media-splide').dataset.totalSlides;
            let currentPostCounter = parentPanel.querySelector('.media-splide-current-slide');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            let mediaSplide = new Splide(panel.querySelector('.media-splide'), {
                type: 'fade',
                speed: 750,
                arrows: false,
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        mediaSplide.go('+1');
                    }
                    else {
                        mediaSplide.go('-1');
                    }
                });
            }

            mediaSplide.on('mounted move', function () {
                if (currentPostCounter) {
                    const updateIndex = setTimeout(() => {
                        let navTitles = panel.querySelectorAll('.media-slider-slide-titles');
                        for (let navTitle of navTitles) {
                            if ((mediaSplide.index).toString() == navTitle.dataset.mediaslideindex) {
                                currentPostCounter.textContent = navTitle.textContent;
                            }
                        }
                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (mediaSplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }

                            if (arrow.dataset.navigate == '-' && (mediaSplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }
                        }
                    }, 50);
                }
            });

            mediaSplide.mount()
        }
        // END MEDIA PANEL SLIDER

        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            let parentPanel = panel.closest('.gallery-panel');
            let galleryThumbnails = parentPanel.querySelectorAll('.gallery-panel-image');
            let lightbox = parentPanel.querySelector('.gallery-panel-lightbox');
            let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            let totalSlides = parentPanel.querySelector('.gallery-splide').dataset.totalSlides;
            let progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);
            let currentPostCounter = parentPanel.querySelector('.gallery-splide-current-slide');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            let lbox = new Splide(panel.querySelector('.gallery-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 rounded-l-lg w-14 h-16 p-2 bg-gray-900 bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-0 2xl:-right-16',
                },
            });

            let gallerySplide = new Splide(panel.querySelector('.gallery-splide'), {
                type: 'slide',
                speed: 750,
                perPage: 4,
                gap: '2rem',
                perMove: 1,
                arrows: true,
                padding: { left: '2rem', right: '2rem' },
                classes: {
                    arrows: 'splide__arrows absolute w-max h-max flex items-center justify-between hidden 1.5xs:flex -top-12 right-6 lg:right-8 gap-4',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 bg-transparent p-2 w-10 h-12 fill-current text-green-brand disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1024: {
                        perPage: 3,
                        padding: { left: '2rem', right: '2rem' },
                        gap: '2rem'
                    },
                    640: {
                        perPage: 2,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                    480: {
                        perPage: 1,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                },
            });

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
                bodyLockToggle();
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
                bodyLockToggle();
            }


            // Closes lightbox on backdrop/close button press

            lightboxBackdrop.addEventListener('click', () => {
                closeLightBox();
            });

            lightboxClose.addEventListener('click', () => {
                closeLightBox();
            });

            // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

            document.addEventListener("keydown", (e) => {
                if (!lightbox.classList.contains('hidden')) {
                    if (e.key === "Escape") {
                        closeLightBox();
                    }
                    else if (e.key === "ArrowRight") {
                        lbox.go('+1');
                    }
                    else if (e.key === "ArrowLeft") {
                        lbox.go('-1');
                    }
                }
            });

            // Opens lightbox and navigates carousel to the thumbnail that was pressed

            for ( let thumbnail of galleryThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        lbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox();
                });
            }

            // Updates carousel progress bar width

            lbox.on('mounted move', function () {
                let end = lbox.Components.Controller.getEnd() + 1;
                progressBar.style.width = String(100 * (lbox.index + 1) / end) + '%';
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        gallerySplide.go('+1');
                    }
                    else {
                        gallerySplide.go('-1');
                    }
                });
            }

            gallerySplide.on('mounted move', function () {
                if (currentPostCounter) {
                    const updateIndex = setTimeout(() => {
                        currentPostCounter.textContent = (gallerySplide.index + 1).toString();
                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (gallerySplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }

                            if (arrow.dataset.navigate == '-' && (gallerySplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }
                        }
                    }, 50);
                }
            });

            lbox.mount();
            gallerySplide.mount()
            gallerySplide.sync(lbox);
        }
        // END GALLERY PANEL SLIDER

        // START INSTAGRAM PANEL SLIDER
        for ( let panel of instagramSplidePanel ) {
            let parentPanel = panel.closest('.instagram-panel');
            let instagramThumbnails = parentPanel.querySelectorAll('.instagram-panel-image');
            let lightbox = parentPanel.querySelector('.instagram-panel-lightbox');
            let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            let currentPostCounter = parentPanel.querySelector('.instagram-splide-current-slide');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
            let totalSlides = parentPanel.querySelector('.instagram-splide').dataset.totalSlides;
            let progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);

            let instagramSplide = new Splide(panel.querySelector('.instagram-splide'), {
                type: 'slide',
                speed: 750,
                perPage: 4,
                gap: '2rem',
                perMove: 1,
                arrows: true,
                padding: { left: '2rem', right: '2rem' },
                classes: {
                    arrows: 'splide__arrows absolute w-max h-max items-center justify-between -top-8 right-6 lg:right-8 gap-4 hidden 1.5xs:flex',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 bg-transparent p-2 w-10 h-12 fill-current text-green-brand disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1024: {
                        perPage: 3,
                        padding: { left: '2rem', right: '2rem' },
                        gap: '2rem'
                    },
                    640: {
                        perPage: 2,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                    480: {
                        perPage: 1,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                },
            });

            let instagramLightbox = new Splide(panel.querySelector('.instagram-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full items-center justify-between flex',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 rounded-l-lg bg-gray-900 bg-opacity-20 md:bg-transparent p-0 w-10 h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-0 2xl:-right-16',
                },
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        instagramSplide.go('+1');
                    }
                    else {
                        instagramSplide.go('-1');
                    }
                });
            }

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
                bodyLockToggle();
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
                bodyLockToggle();
            }

            for ( let thumbnail of instagramThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        instagramLightbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox();
                });
            }

            if (lightbox) {
                // Closes lightbox on backdrop/close button press

                document.addEventListener("keydown", (e) => {
                    if (!lightbox.classList.contains('hidden')) {
                        if (e.key === "Escape") {
                            closeLightBox();
                        }
                        else if (e.key === "ArrowRight") {
                            instagramLightbox.go('+1');
                        }
                        else if (e.key === "ArrowLeft") {
                            instagramLightbox.go('-1');
                        }
                    }
                });

                instagramLightbox.on('mounted move', function () {
                    let end = instagramLightbox.Components.Controller.getEnd() + 1;
                    progressBar.style.width = String(100 * (instagramLightbox.index + 1) / end) + '%';
                });

                lightboxBackdrop.addEventListener('click', () => {
                    closeLightBox();
                });

                lightboxClose.addEventListener('click', () => {
                    closeLightBox();
                });
            }

            instagramSplide.on('mounted move', function () {
                if (currentPostCounter) {
                    const updateIndex = setTimeout(() => {
                        currentPostCounter.textContent = (instagramSplide.index + 1).toString();
                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (instagramSplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }

                            if (arrow.dataset.navigate == '-' && (instagramSplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }
                        }
                    }, 50);
                }
            });

            instagramSplide.sync(instagramLightbox);
            instagramSplide.mount();
            instagramLightbox.mount();
        }
        // END INSTAGRAM PANEL SLIDER

        // START ELEVATIONS PANEL SLIDER
        for ( let panel of elevationsSplidePanel ) {
            let elevationThumbnails = panel.querySelectorAll('.elevation-card-zoom');
            let lightbox = panel.querySelector('.elevations-panel-lightbox');
            let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            let progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);
            let navArrows = panel.querySelectorAll('.splide-nav-arrow');
            let pinchZoomObjects = panel.querySelectorAll('.pinchzoom-me');

            for (let zoom of pinchZoomObjects) {
                let pinchZoomer = new PinchZoom(zoom);
            }

            let elevationLightBoxSplide = new Splide(panel.querySelector('.elevations-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-auto bottom-8 flex items-center justify-between',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 rounded-l-lg w-14 h-16 p-2 bg-green-brand/40 3xl:rounded-r-lg fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 rotate-180',
                    next: 'splide__arrow--next right-0',
                },
                noDrag: 'null',
                breakpoints: {
                    768: {
                        noDrag: '*',
                    },
                },
            });

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
                bodyLockToggle();
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
                bodyLockToggle();
            }


            // Closes lightbox on backdrop/close button press

            lightboxBackdrop.addEventListener('click', () => {
                closeLightBox();
            });

            lightboxClose.addEventListener('click', () => {
                closeLightBox();
            });

            // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

            document.addEventListener("keydown", (e) => {
                if (!lightbox.classList.contains('hidden')) {
                    if (e.key === "Escape") {
                        closeLightBox();
                    }
                    else if (e.key === "ArrowRight") {
                        elevationLightBoxSplide.go('+1');
                    }
                    else if (e.key === "ArrowLeft") {
                        elevationLightBoxSplide.go('-1');
                    }
                }
            });

            // Opens lightbox and navigates carousel to the thumbnail that was pressed

            for ( let thumbnail of elevationThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        elevationLightBoxSplide.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox();
                });
            }

            // Updates carousel progress bar width

            elevationLightBoxSplide.on('mounted move', function () {
                let end = elevationLightBoxSplide.Components.Controller.getEnd() + 1;
                progressBar.style.width = String(100 * (elevationLightBoxSplide.index + 1) / end) + '%';
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        elevationLightBoxSplide.go('+1');
                    }
                    else {
                        elevationLightBoxSplide.go('-1');
                    }
                });
            }

            elevationLightBoxSplide.mount();
        }
        // END ELEVATIONS PANEL SLIDER
    }
});
